import { Layout } from 'antd';
import * as React from 'react';
import 'src/assets/less/index.less';
import 'src/assets/less/mall.less';
import MRouter from 'src/routers/MRouter';
import BreadcrumbLayout from './BreadcrumbLayout';
import HeaderLayout from 'src/containers/HeaderLayout';
import SideLayout from 'src/containers/SideLayout';
import { RouteComponentProps, withRouter } from 'react-router';
import { RouterConfig } from 'src/routers/urlConfig';
import WebSocketService, { WSMessageType, WSMessage } from 'src/services/WebSocketService';
import { EPayStatus } from 'src/constants/Order';
import { OperatingService } from '../../services/OperatingService';
import { IAgentInfo } from '../../entity/AgentEntity';
import { IDrugStoreInfo } from '../../entity/DrugStoreEntity';
const { Content } = Layout;

// const PrimaryLayout = () => {
//   return (
//     <Layout style={{ overflowY: 'hidden' }}>
//       <SideLayout />
//       <Layout style={{ flexDirection: 'column' }}>
//         <HeaderLayout />
//         <BreadcrumbLayout />
//         <Content className="content-box">
//           <MRouter />
//         </Content>
//       </Layout>
//     </Layout>
//   );
// };

// export default PrimaryLayout;

interface PrimaryLayoutProps extends RouteComponentProps {
  menuItem: RouterConfig.IMenuItems;
  isAgent: boolean;
  userInfo: IAgentInfo | IDrugStoreInfo | undefined;
  getDoctorToApprove: () => void;
  getDoctorNeedConfigure: () => void;
  getOrderPending: (hasNewOrder: boolean) => void;
  setPreOrderSendStatus: (orderUUID: string) => void;
}

class PrimaryLayout extends React.Component<PrimaryLayoutProps> {
  constructor(props: PrimaryLayoutProps) {
    super(props);
  }

  componentDidMount() {
    this.props.history.listen(route => {
      OperatingService.addOperating(route.pathname);
    });

    this.getNotifyInfo();

    WebSocketService.setCallBack({
      onMessageBack: this.wsReceiveMessageListener,
    });

    if (this.props.isAgent) {
      WebSocketService.sendMessage({ type: WSMessageType.绑定待认证医生 });
    } else {
      WebSocketService.sendMessage({ type: WSMessageType.绑定订单状态 });
      // Notice 配药中心需要监听发送药品清单结果
      if (this.props.userInfo) {
        WebSocketService.sendMessage({ type: WSMessageType.COMMONBIND, group_name: `${WSMessageType.绑定发送药品清单结果}_${this.props.userInfo.id}` })
      }
    }
  }

  wsReceiveMessageListener = (receiveMessage: WSMessage) => {
    if (!!receiveMessage && !!this.props.userInfo) {
      switch (receiveMessage.type) {
        case WSMessageType.获取待审核医生:
          this.props.getDoctorToApprove();
          break;
        case WSMessageType.获取待配置医生:
          this.props.getDoctorNeedConfigure();
          break;
        case WSMessageType.获取待处理订单:
          if (!!receiveMessage.from_drug_store_id && receiveMessage.from_drug_store_id === this.props.userInfo.id) {
            this.props.getOrderPending(receiveMessage.current_pay_status === EPayStatus.待发货 || receiveMessage.current_pay_status === EPayStatus.线下待支付);
          }
          break;
        case WSMessageType.发送药品清单结果:
          if (!!receiveMessage.order_id && receiveMessage.status === 'SUCCESS') {
            this.props.setPreOrderSendStatus(receiveMessage.order_id);
          }
        default:
          this.getNotifyInfo();
          break;
      }
    }
  };

  getNotifyInfo = () => {
    if (this.props.isAgent) {
      this.props.getDoctorToApprove();
      this.props.getDoctorNeedConfigure();
    } else {
      this.props.getOrderPending(false);
    }
  }

  render() {
    return (
      <Layout style={{ overflowY: 'hidden' }}>
        <SideLayout />
        <Layout style={{ flexDirection: 'column' }}>
          <HeaderLayout />
          <BreadcrumbLayout menuItem={this.props.menuItem} />
          <Content className="content-box">
            <MRouter menuItem={this.props.menuItem} />
          </Content>
        </Layout>
      </Layout>
    );
  }
}

export default withRouter(PrimaryLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/PrimaryLayout.tsx